import classesK from '../kalkulatori.module.css'
import classes from './dalembert.module.css'
import { useState } from 'react'
import InfoBar from '../redesign/components/InfoBar'
import ResultsSection from '../redesign/components/ResultsSection'
import add from '../images/add.svg'
import runCalculator from '../api/runCalculator'

const category = 'strategies'
const slug = 'dalembert'

const calculatorType = 'D alembert'
const Dalembert = () => {
  const [showInputArea, setShowInputArea] = useState(true)
  const initialValues = {
    ulogArr: new Array(21).fill(''),
    kvotaArr: new Array(21).fill(''),
    dobitakArr: new Array(21).fill(0),
    trenutnoStanjeArr: new Array(21).fill(0),
    prolazUpisArr: new Array(21).fill(''),
    isActive: [true, ...new Array(20).fill(false)],
    totalStanje: 0,
  }

  const [games, setGames] = useState([{ id: 1 }])
  const [data, setData] = useState({ values: initialValues })
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  // Build the API request body from the current input state, matching the
  // golden `input` shape (English keys). Raw input strings are parsed the same
  // way the component reads them (Number(v) || 0).
  const buildBody = (values) => ({
    initialStake: Number(values.ulogArr[0]) || 0,
    oddsList: values.kvotaArr.map((v) => Number(v) || 0),
    outcomes: values.prolazUpisArr.map((v) => {
      const prolaz = (v || '').toLowerCase()
      if (prolaz === 'da') return 'DA'
      if (prolaz === 'ne') return 'NE'
      return null
    }),
  })

  // Map the English API response (shaped like golden `output`) back into the
  // existing data.values shape the JSX consumes. The raw user inputs
  // (ulogArr[0], kvotaArr, prolazUpisArr controlled fields) are preserved; only
  // the computed columns are sourced from the API.
  const applyResults = (prevValues, out) => {
    const rows = out.rows || []

    const ulogArr = prevValues.ulogArr.map((v, index) => {
      if (index === 0) return v
      const stake = rows[index]?.stake
      return stake == null ? 0 : stake
    })

    const dobitakArr = prevValues.kvotaArr.map((_, index) => {
      const grossWin = rows[index]?.grossWin
      return grossWin == null ? 0 : grossWin
    })

    const trenutnoStanjeArr = prevValues.kvotaArr.map((_, index) => {
      const balance = rows[index]?.currentBalance
      return balance == null ? 0 : balance
    })

    return {
      ...prevValues,
      ulogArr,
      dobitakArr,
      trenutnoStanjeArr,
      totalStanje: out.currentBalanceTotal == null ? 0 : out.currentBalanceTotal,
      isActive: prevValues.prolazUpisArr.map((v) => (v || '').toLowerCase() === 'da'),
    }
  }

  const calculateAll = async (values) => {
    setLoading(true)
    setError('')
    try {
      const out = await runCalculator(category, slug, buildBody(values))
      setData({ values: applyResults(values, out) })
    } catch (e) {
      setError('Greška pri obračunu, pokušajte ponovo.')
    } finally {
      setLoading(false)
    }
  }

  const addSeries = () => {
    setData((prevData) => {
      const prevValues = prevData.values

      return {
        values: {
          ...prevValues,
          ulogArr: [...prevValues.ulogArr, ''],
          kvotaArr: [...prevValues.kvotaArr, ''],
          prolazUpisArr: [...prevValues.prolazUpisArr, ''],
          dobitakArr: [...prevValues.dobitakArr, ''],
          trenutnoStanjeArr: [...prevValues.trenutnoStanjeArr, ''],
          isActive: [...prevValues.isActive, false],
          totalStanje: prevValues.totalStanje,
        },
      }
    })

    setGames((prev) => [...prev, { id: prev.length + 1 }])
  }

  const clearFields = () => {
    const resetValues = {
      ulogArr: new Array(21).fill(''),
      kvotaArr: new Array(21).fill(''),
      dobitakArr: new Array(21).fill(0),
      trenutnoStanjeArr: new Array(21).fill(0),
      prolazUpisArr: new Array(21).fill(''),
      isActive: [true, ...new Array(20).fill(false)],
      totalStanje: 0,
    }

    setShowInputArea(true)
    setData({ values: resetValues })
    setGames([{ id: 1 }])
    setError('')
    setLoading(false)
  }

  return (
    <div className={classesK.container}>
      <InfoBar calculatorType={calculatorType} onRefresh={clearFields} />
      <div className={classesK.contentContainer}>
        {showInputArea && (
          <>
            <div className={classesK.sectionTitle}>Ukupno trenutno stanje</div>
            <ResultsSection
              subtitle={'Prikaz trenutnog stanja'}
              names={['Tvoja trenutna banka']}
              results={[data.values.totalStanje]}
            />
            {games.map((game, index) => (
              <div className={classes.gameContainer} key={game.id}>
                <div className={classes.gameTitle}>Igra br. {game.id}</div>
                <div className={classes.inputContainer}>
                  {index === 0 ? (
                    <div className={classesK.oddsContainer}>
                      <span>Upiši ulog</span>
                      <input
                        type='number'
                        value={data.values.ulogArr[index]}
                        onChange={(e) => {
                          const updatedUlog = [...data.values.ulogArr]
                          updatedUlog[index] = e.target.value
                          setData({
                            values: { ...data.values, ulogArr: updatedUlog },
                          })
                        }}
                        step='1'
                        min='1'
                        rows={1}
                        style={{ width: '100%' }}
                      />
                    </div>
                  ) : (
                    <ResultsSection
                      names={['Ulog']}
                      results={[Number(data.values.ulogArr[index]).toFixed(2)]}
                    />
                  )}

                  <div className={classes.oddsCalcWrapper}>
                    <div className={classes.inputsWrapper}>
                      <div className={classes.oddsContainer}>
                        <span>Upiši kvotu</span>
                        <input
                          type='number'
                          step='0.1'
                          min='0.1'
                          value={data.values.kvotaArr[index]}
                          onChange={(e) => {
                            const updatedKvota = [...data.values.kvotaArr]
                            updatedKvota[index] = e.target.value
                            setData({
                              values: { ...data.values, kvotaArr: updatedKvota },
                            })
                          }}
                          style={{ width: '100%' }}
                        />
                      </div>

                      <div className={classes.oddsContainer}>
                        <span>Upiši prolaz (da/ne)</span>
                        <input
                          type='text'
                          value={data.values.prolazUpisArr[index]}
                          onChange={(e) => {
                            const updatedProlaz = [...data.values.prolazUpisArr]
                            updatedProlaz[index] = e.target.value
                            setData({
                              values: {
                                ...data.values,
                                prolazUpisArr: updatedProlaz,
                              },
                            })
                          }}
                          style={{ width: '100%' }}
                        />
                      </div>
                    </div>

                    <ResultsSection
                      names={['Obračunski podaci', 'Dobitak u ovoj seriji']}
                      rows={2}
                      results={[
                        Number(data.values.trenutnoStanjeArr[index]).toFixed(2),
                        Number(data.values.dobitakArr[index]).toFixed(2),
                      ]}
                      allowNegative={true}
                    />
                  </div>
                </div>
              </div>
            ))}
            <div className={classesK.addMore}>
              <button
                onClick={() => calculateAll(data.values)}
                className={classesK.addButton}
                disabled={loading}
              >
                {loading ? 'Obračun u toku...' : 'Prikaži rezultate'}
              </button>
            </div>
            {error && (
              <div className={classesK.sectionTitle} style={{ color: 'red' }}>
                {error}
              </div>
            )}
          </>
        )}
        {games.length < 25 && (
          <div className={classesK.addMore}>
            <button onClick={addSeries} className={classesK.addButton}>
              <img src={add} height={18} width={18} alt='image' />
              Dodaj još jednu seriju
            </button>
          </div>
        )}
      </div>
    </div>
  )
}
export default Dalembert
